/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BuildingFuture } from './BuildingFuture';
import {
    BuildingFutureFromJSON,
    BuildingFutureFromJSONTyped,
    BuildingFutureToJSON,
    BuildingFutureToJSONTyped,
} from './BuildingFuture';
import type { BuildingOccupancy } from './BuildingOccupancy';
import {
    BuildingOccupancyFromJSON,
    BuildingOccupancyFromJSONTyped,
    BuildingOccupancyToJSON,
    BuildingOccupancyToJSONTyped,
} from './BuildingOccupancy';

/**
 * 
 * @export
 * @interface BuildingDto
 */
export interface BuildingDto {
    /**
     * 
     * @type {string}
     * @memberof BuildingDto
     */
    id?: string;
    /**
     * Levels above ground (R+n).
     * @type {number}
     * @memberof BuildingDto
     */
    floorsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BuildingDto
     */
    basementsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BuildingDto
     */
    area?: number | null;
    /**
     * 
     * @type {BuildingOccupancy}
     * @memberof BuildingDto
     */
    occupancy?: BuildingOccupancy | null;
    /**
     * 
     * @type {boolean}
     * @memberof BuildingDto
     */
    accessWalledUp?: boolean | null;
    /**
     * 
     * @type {BuildingFuture}
     * @memberof BuildingDto
     */
    future?: BuildingFuture | null;
}



/**
 * Check if a given object implements the BuildingDto interface.
 */
export function instanceOfBuildingDto(value: object): value is BuildingDto {
    return true;
}

export function BuildingDtoFromJSON(json: any): BuildingDto {
    return BuildingDtoFromJSONTyped(json, false);
}

export function BuildingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'floorsCount': json['floorsCount'] == null ? undefined : json['floorsCount'],
        'basementsCount': json['basementsCount'] == null ? undefined : json['basementsCount'],
        'area': json['area'] == null ? undefined : json['area'],
        'occupancy': json['occupancy'] == null ? undefined : BuildingOccupancyFromJSON(json['occupancy']),
        'accessWalledUp': json['accessWalledUp'] == null ? undefined : json['accessWalledUp'],
        'future': json['future'] == null ? undefined : BuildingFutureFromJSON(json['future']),
    };
}

export function BuildingDtoToJSON(json: any): BuildingDto {
    return BuildingDtoToJSONTyped(json, false);
}

export function BuildingDtoToJSONTyped(value?: BuildingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'floorsCount': value['floorsCount'],
        'basementsCount': value['basementsCount'],
        'area': value['area'],
        'occupancy': BuildingOccupancyToJSON(value['occupancy']),
        'accessWalledUp': value['accessWalledUp'],
        'future': BuildingFutureToJSON(value['future']),
    };
}

